import { render, staticRenderFns } from "./facturList.vue?vue&type=template&id=27027df4&scoped=true"
import script from "./facturList.vue?vue&type=script&lang=js"
export * from "./facturList.vue?vue&type=script&lang=js"
import style0 from "./facturList.vue?vue&type=style&index=0&id=27027df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27027df4",
  null
  
)

export default component.exports